import { useState, useEffect } from 'react';
import './App.css';
import BootstrapMessaging from './bootstrapMessaging';
import Prechat from './components/prechat';
import { useInactivityTimer } from './useInactivityTimer';
import { clearInMemoryData } from './services/dataProvider';

function App() {
  const [currentPage, setCurrentPage] = useState('prechat');
  const [userEmail, setUserEmail] = useState('');
  const [authToken, setAuthToken] = useState('');

  useEffect(() => {
    const savedEmail = localStorage.getItem('userEmail');
    if (savedEmail) {
      setUserEmail(savedEmail);
      setCurrentPage('chat');
    }
  }, []);


  // useInactivityTimer(50000); 

  const handlePrechatSuccess = (formData) => {
    const email = formData['メールアドレスを入力してください'];
    const token = formData['authToken'];
    localStorage.setItem('userEmail', email);
    localStorage.setItem('authToken', token);
    setUserEmail(email);
    setAuthToken(token);
    setCurrentPage('chat');
  };

  // --- NEW: Create the logout function ---
  const handleLogout = () => {
    console.log('Logging out...');
    // 1. Remove the email from localStorage
    localStorage.removeItem('userEmail');
    localStorage.removeItem('authToken')
    // 2. Reset the state to show the login page
    setUserEmail('');
    setAuthToken('');
    clearInMemoryData();
    setCurrentPage('prechat');
  };

  return (
    <div className="App">
      <header className="App-header">
        {currentPage === 'prechat' ? (
          <Prechat onPrechatSubmit={handlePrechatSuccess} />
        ) : (
          // --- NEW: Pass the handleLogout function as a prop ---
          <BootstrapMessaging email={userEmail} onLogout={handleLogout} authToken={authToken} />
        )}
      </header>
    </div>
  );
}

export default App;